export default "__VITE_ASSET__jMfjVAOa__"